exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".green[data-v-22683a66] {\n  color: #27ae60;\n}\n.red[data-v-22683a66] {\n  color: #e74c3c;\n}\n", ""]);

// exports
